const emptyEducation = {
  degreeName: "",
  degreeCertificateUrl: "",
  fieldOfStudy: "",
  fromDate: "",
  toDate: "",
  gradeOrcgpa: "",
  institutionName: "",
  location: "",
  rollNumber: "",
};

const initialState = {
  personalDetails: {
    firstName: "",
    lastName: "",
    middleName: "",
    gender: "",
    imageUrl: "",
    fatherName: "",
    motherName: "",
    personalEmail: "",
    country: "",
    nationality: "",
    aadhaarNo: "",
    panNo: "",
    panUrl: "",
    uanNo: "",
    secondaryMobile: "",
    adhaarUrl: "",
  },
  contactDetails: [
    {
      address1: "",
      address2: "",
      address3: "",
      addressType: "",
      city: "",
      state: "",
      zip: "",
      emergencyContactName: "",
      emergencyContactNumber: "",
      field1: "",
      field2: "",
    },
    {
      address1: "",
      address2: "",
      address3: "",
      addressType: "",
      city: "",
      state: "",
      zip: "",
      emergencyContactName: "",
      emergencyContactNumber: "",
      field1: "",
      field2: "",
    },
  ],
  educationalDetails: new Array(5).fill(null).map(() => ({ ...emptyEducation })),
  experienceDetails: [
    {
      previousEmployerName: "",
      department: "",
      designation: "",
      employeeCode: "",
      employmentPeriodFrom: "",
      employmentPeriodTo: "",
      reasonForLeaving: "",
      positionType: "",
      mobileNumber: "",
      managerName: "",
      managerEmail: "",
      managerContactNo: "",
      address: "",
      appointmentLetterUrl: "",
      relievingLetterUrl: "",
      experienceCertificateUrl: "",
      lastMonthSalarySlip1url: "",
      lastMonthSalarySlip2url: "",
      lastMonthSalarySlip3url: "",
      lastThreeMonthBankStatementurl: "",
    },
  ],
  additionalDetails: {
    country: "",
    passportCopy: "",
    passportCopyUrl: "",
    status: "",
    workPermitDetails: "",
    workPermitValidTill: "",
    countryOfIssue: "",
    dateOfIssue: "",
    nationality: "",
    passportNumber: "",
    passportUrl: "",
    placeOfIssue: "",
    validUpto: "",
    hobbiesDeclaration: "",
    illnessDeclaration: "",
    illnessDeclarationDocUrl: "",
    signatureUrl: "",
    place: "",
    previewDate: "",
    field1: "",
    field2: "",
  },
  professionalReferences: [
    {
      name: "",
      email: "",
      contactNumber: "",
      companyName: "",
      designation: "",
      relationship: "",
      employeeId: "",
      department: "",
      isRelative: "",
    },
    {
      name: "",
      email: "",
      contactNumber: "",
      companyName: "",
      designation: "",
      relationship: "",
      employeeId: "",
      department: "",
      isRelative: "",
    },
  ],
  inviteData: {
    id: "",
    fullName: "",
    firstName: "",
    lastName: "",
    middleName: "",
    email: "",
  },
  formStep: {
    Step: '',
  },
  savedPermissions:{
    permissions:[],
    userId:"",
    roleName:"",
    email: "",
    isApprover: "",
  },

};

const formsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SAVE_PERSONAL_DETAILS":
      return { ...state, personalDetails: action.payload };
    case "SAVE_CONTACT_DETAILS":
      return { ...state, contactDetails: action.payload };
    case "SAVE_EDUCATIONAL_DETAILS":
      return { ...state, educationalDetails: action.payload };
    case "SAVE_EXPERIENCE_DETAILS":
      return { ...state, experienceDetails: action.payload };
    case "SAVE_ADDITIONAL_DETAILS":
      return { ...state, additionalDetails: action.payload };
    case "SAVE_PROFESSIONALREFERENCES_DETAILS":
      return { ...state, professionalReferences: action.payload };
    case "SAVE_DATA":
      return { ...state, inviteData: action.payload };
    case "CLEAR_FORM_DATA":
      return initialState;
    case "GO_NEXT":
      return { ...state, formStep: action.payload };
    case "GO_BACK":
      return { ...state, formStep: action.payload };
    case "SAVE_PERMISSIONS":
      return { ...state, savedPermissions: action.payload };
    default:
      return state;
  }
};

export default formsReducer;
